import React, { Component } from 'react'
import { connect } from 'react-redux'
import { checkAuth } from 'store/auth/operations'
import { Loader } from 'sputnik-ui'
import { fetchCurrentPartner } from 'store/partners/operations'
import { withTranslation } from 'react-i18next'

export default function requireAuth(C) {
  class Authentication extends Component {
    componentDidMount() {
      // check session
      this.props.dispatch(checkAuth())
      this.props.dispatch(fetchCurrentPartner())
    }

    render() {
      const { isLoggedIn } = this.props

      if (!isLoggedIn) {
        return (
          <Loader msg={this.props.t('common:loaders.check_auth')} fullPage />
        )
      }

      return <C {...this.props} />
    }
  }

  const mapStateToProps = ({ auth }) => ({
    isLoggedIn: auth.isLoggedIn,
  })

  return connect(mapStateToProps)(withTranslation(['common'])(Authentication))
}
